export function getApiBaseUrl() {
  const envBaseUrl = import.meta.env.VITE_API_BASE_URL;

  if (typeof window !== "undefined") {
    const vitePort = import.meta.env.VITE_PORT;

    if (vitePort && window.location.host.includes(vitePort)) {
      return "https://sing.dev.theworshipinitiative.com/api";
    }

    if (envBaseUrl) {
      return envBaseUrl;
    }

    if (window.location.hostname === "localhost") {
      return "https://sing.dev.theworshipinitiative.com/api";
    }

    return `${window.location.protocol}//${window.location.host}/api`;
  }

  return envBaseUrl || "https://sing.dev.theworshipinitiative.com/api";
}
